import axios from "axios";

// Base URL of the VEYSO API. Do not add /v1 here.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:8080";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

let getAccessToken = null;

/** Called once after sign-in so requests can carry the user's access token. */
export const initializeApi = (tokenGetter) => {
  getAccessToken = tokenGetter;
};

// Attach the token when there is one. Public endpoints work with or without it.
// Tokens are never logged.
api.interceptors.request.use(async (config) => {
  if (getAccessToken) {
    try {
      const token = await getAccessToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch {
      /* not signed in: send the request without a token */
    }
  }
  return config;
});

export default api;
